var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 236 256",
    enableBackground: "new 0 0 236 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2,118v27h23v109h185V145h24v-27H2z M101.94,185.7h9.28v-4.64h-9.28v-6.05h9.28v-4.64h-9.28v-6.04h9.28v-4.64h-9.21 c0.21-7.81,6.6-14.13,14.48-14.13h2.95c7.88,0,14.27,6.32,14.55,14.13h-9.56v4.64h9.63v6.04h-9.63v4.57h9.63v6.05h-9.63v4.64h9.56 v0.42c0,8.02-6.53,14.56-14.55,14.56h-2.95c-8.02,0-14.55-6.54-14.55-14.49V185.7z M143.84,186.9c0,12.37-9.35,22.49-21.38,23.97 v9.63l7.39,6.26h3.3v3.8h-30.3v-3.8h3.37l7.17-6.05v-9.91c-11.95-1.55-21.23-11.67-21.23-23.97v-8.02h4.57v8.02 c0,10.82,8.79,19.68,19.69,19.68h3.16c10.83,0,19.69-8.79,19.69-19.68v-8.02h4.57V186.9z M146,52H89c-15.59,0-28,13.41-28,29v32h20 V86c0-1.71,1.29-3,3-3s3,1.29,3,3v27h61V86c0-1.71,1.29-3,3-3s3,1.29,3,3v27h20V81C174,65.51,161.49,52,146,52z M117.5,2 c-12.47,0-22.63,10.16-22.63,22.63c0,12.46,10.06,22.62,22.63,22.62c12.37,0,22.62-10.16,22.62-22.62C140.12,12.16,129.97,2,117.5,2 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHost);
export default __webpack_public_path__ + "static/media/host.cc2b826e095d5d4ff0a4392dfd5227c6.svg";
export { ForwardRef as ReactComponent };